import MSettingsPanel from './MSettingsPanel.vue';

export { MSettingsPanel };
export default MSettingsPanel;
